// src/components/BookingPage/AvailableTimes.js

import React from 'react';
import { Typography, Box, Grid, Button, CircularProgress } from '@mui/material';

export default function AvailableTimes({
  loading,
  availableStartTimes,
  selectedStartTime,
  selectedEmployee,
  setSelectedStartTime,
  setSelectedEmployee,
}) {
  return (
    <Box sx={{ mb: 3 }}>
      {loading ? (
        <CircularProgress />
      ) : availableStartTimes.length === 0 ? (
        <Typography>Keine verfügbaren Termine für dieses Datum.</Typography>
      ) : (
        <Grid container spacing={2}>
          {availableStartTimes.map((slot, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Button
                variant={
                  selectedStartTime === slot.startTime && selectedEmployee === slot.employeeId
                    ? 'contained'
                    : 'outlined'
                }
                fullWidth
                onClick={() => {
                  setSelectedStartTime(slot.startTime);
                  setSelectedEmployee(slot.employeeId);
                }}
                sx={{ textTransform: 'none' }}
              >
                {slot.startTime} Uhr mit {slot.employeeName}
              </Button>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
}
